import React from 'react';
// import { X } from 'lucide-react';
import {
  Sheet,
  SheetContent,
} from 'src/components/ui/sheet';
import { Company } from 'src/pages/billing/types/billing.types';
import { Invoice, Terms } from 'src/redux/billing/billing.types';
// import { Button } from 'src/components/ui/button';
import { SKU } from 'src/redux/billing/billing.types';
import InvoiceDrawerHeader from './invoice-drawer-header';
import InvoiceDrawerLineTable from './invoice-drawer-line-table';

interface InvoiceDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  invoice?: Invoice | null; // null for create mode, string for edit mode
  invoices: Invoice[];
  companies?: Company[];
  skus?: SKU[];
  terms?: Terms[];
  //   children: React.ReactNode;
  title?: string;
  updateInvoice: (invoiceId: string, field: string, value: any) => void;
  updateLineItem: (lineItemId: string, field: string, value: any) => void;
  refetchInvoiceGroup: () => void;
  //   description?: string;
}

export const InvoiceDrawer: React.FC<InvoiceDrawerProps> = ({
  open,
  onOpenChange,
  invoice,
  invoices,
  companies,
  skus,
  terms,
  //   children,
  title,
  //   description,
  updateInvoice,
  updateLineItem,
  refetchInvoiceGroup,
}) => {
  const isEditMode = !!invoice;

  return (
    <Sheet
      open={open}
      onOpenChange={onOpenChange}
    >
      <SheetContent
        side="right"
        className="!w-[75vw] sm:!w-[75vw] !max-w-none overflow-y-auto bg-white"
        // onInteractOutside={(e) => {
        //   e.preventDefault();
        // }}
      >
        <InvoiceDrawerHeader
          invoice={invoice}
          companies={companies}
          terms={terms}
          refetchInvoiceGroup={refetchInvoiceGroup}
          updateInvoice={updateInvoice}
        />

        <div className="mt-6">
          <InvoiceDrawerLineTable
            invoice={invoice}
            skus={skus}
            companies={companies || []}
            invoices={invoices}
            updateLineItem={updateLineItem}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default InvoiceDrawer;